import { render, staticRenderFns } from "./BlogEditor.vue?vue&type=template&id=395b317c&scoped=true&"
import script from "./BlogEditor.vue?vue&type=script&lang=js&"
export * from "./BlogEditor.vue?vue&type=script&lang=js&"
import style0 from "./BlogEditor.vue?vue&type=style&index=0&id=395b317c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b317c",
  null
  
)

export default component.exports